import { PlusOutlined } from "@ant-design/icons";
import { Button, Space } from "antd";
import type { FC } from "react";
import { useAudienceContext } from "../providers/AudienceContext";

export interface AudienceActionsProps {
	loading?: boolean;
	className?: string;
	actionBtnLabel?: string;
}

const AudienceActions: FC<AudienceActionsProps> = ({
	loading = false,
	className = "",
	actionBtnLabel = "新規作成",
}) => {
	const { activeTabIndex, tabs, openModal, publicSettings } =
		useAudienceContext();

	const handleOpen = () => {
		openModal("search");
	};

	// Get the current tab label from the registered tabs
	const currentTypeLabel = tabs[activeTabIndex]?.label || "";

	return (
		<div
			className={`audience-actions flex justify-between items-center mb-2 ${className}`}
		>
			<div className="actions-left">
				<h3 className="text-lg font-semibold mb-0">{currentTypeLabel}</h3>
			</div>

			<div className="actions-right flex justify-end">
				<Space size="middle">
					<Button
						type="primary"
						size="large"
						icon={<PlusOutlined />}
						onClick={handleOpen}
						disabled={loading}
						style={{
							backgroundColor: publicSettings?.PRIMARY_COLOR?.valueString,
							borderColor: publicSettings?.PRIMARY_COLOR?.valueString,
						}}
					>
						{actionBtnLabel}
					</Button>
				</Space>
			</div>
		</div>
	);
};

export default AudienceActions;
